module.exports = __webpack_public_path__ + "img/Bear00.8aa23182.jpg";